import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React, { useEffect } from "react";
import { Formik, Form } from "formik";
import { Debug } from "../../../Molecules/Forms/Debug";
import { TaskDetailForm, Drawer, makeStyles, Grid, Button, SubmitButton, TaskDetailInfo } from "../../../";
import * as Yup from "yup"; // import { Debug } from '../../../Molecules/Forms/Debug';

var useStyles = makeStyles({
  list: {
    width: 550,
    "box-shadow": "-4px 0px 38px 0px #84848473",
    height: "100vh",
    padding: "10px"
  },
  actions: {
    display: "flex",
    padding: "30px",
    "justify-content": "flex-end"
  },
  mr30: {
    "margin-right": "30px"
  }
});
var ProjectTaskDetailSchema = Yup.object().shape({
  type: Yup.string(),
  date: Yup.date()["default"](function () {
    return new Date();
  }),
  state: Yup.string(),
  opportunityState: Yup.string(),
  details: Yup.string()
});

var TaskDetailDrawer = function TaskDetailDrawer(props) {
  // console.log("TaskDetailDrawer props");
  var open = props.open,
      toggleDrawer = props.toggleDrawer,
      task = props.task,
      titles = props.titles,
      handleButtonActionTask = props.handleButtonActionTask,
      handleButtonActionTaskRecurrency = props.handleButtonActionTaskRecurrency,
      translation = props.translation;
  var initialValues = {}; //TODO use Effect con metodo getInitialValues no funciona, codigo interno de función añadido directamente en useEfftect()

  useEffect(function () {
    // console.log("use effect taskdetaildrawer", task.extraFields);
    task.extraFields && task.extraFields.forEach(function (field, i) {
      // console.log("field", field);
      // console.log("task[field.value]", task.extraFields[i].value);
      // console.log("field", field);
      task ? initialValues[field.name] = task.extraFields[i].value : field.type === "date" ? initialValues[field.name] = null : initialValues[field.name] = ""; // console.log("initialValues[field.name]", initialValues[field.name]);
      // console.log("initialValues", initialValues);
    });
  }, [task, initialValues]); //get initialValues from extrafields in task
  //TODO Ver y Editar cuando hay valores guardados en la tarea
  //   const getInitialValues = fields => {
  //     console.log("fields", fields);
  //     fields.forEach((field, i) => {
  //       console.log("field", field);
  //       console.log("task[field.value]", task.extraFields[i].value);
  //       console.log("field", field);
  //       task
  //         ? (initialValues[field.name] = task.extraFields[i].value)
  //         : field.type === "date"
  //         ? (initialValues[field.name] = null)
  //         : (initialValues[field.name] = "");
  //       console.log("initialValues[field.name]", initialValues[field.name]);
  //       console.log("initialValues", initialValues);
  //     });
  //   };

  var setValues = function setValues(values) {
    // console.log('values en setValues', values);
    var newTask = _objectSpread({}, props.task);

    newTask.extraFields.forEach(function (field) {
      // console.log('newTask field', field);
      for (var key in values) {
        // console.log('key', key);
        if (key === field.name) field.value = values[key];
      }
    }); // console.log("new Task to save", newTask);

    props.editContentTask(newTask);
    props.onClose();
  };

  var classes = useStyles();

  var handleFinishTask = function handleFinishTask() {// console.log("finish task clicked");
    // Falta ver cómo comprobar si el formulario ha sido finalizado y completado
  };

  var sideContent = function sideContent() {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.list,
      role: "presentation"
    }, /*#__PURE__*/React.createElement(TaskDetailInfo, {
      task: task,
      titles: titles,
      handleFinishTask: handleFinishTask,
      translation: translation ? translation : null,
      handleButtonActionTask: handleButtonActionTask,
      handleButtonActionTaskRecurrency: handleButtonActionTaskRecurrency
    }), /*#__PURE__*/React.createElement(Formik, {
      initialValues: initialValues,
      validationSchema: ProjectTaskDetailSchema,
      onSubmit: function onSubmit(values, _ref) {
        var resetForm = _ref.resetForm;
        // console.log(JSON.stringify(values));
        setValues(values);
      },
      render: function render(_ref2) {
        var values = _ref2.values,
            isValid = _ref2.isValid,
            isSubmitting = _ref2.isSubmitting;
        return /*#__PURE__*/React.createElement(Form, {
          className: classes.form
        }, /*#__PURE__*/React.createElement(Grid, {
          container: true,
          className: classes.root
        }, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          md: 12,
          className: classes.editor
        }, /*#__PURE__*/React.createElement(TaskDetailForm, {
          values: values,
          task: task
        }), props.variant !== "view" && /*#__PURE__*/React.createElement(Grid, {
          container: true,
          className: classes.actions
        }, /*#__PURE__*/React.createElement(Button, {
          size: "medium",
          color: "primary",
          variant: "outlined",
          disabled: !isValid || isSubmitting,
          component: SubmitButton,
          type: "submit"
        }, props.variant === "add" ? "Añadir" : "Guardar")))));
      }
    }));
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Drawer, {
    anchor: "right",
    open: open,
    onClose: toggleDrawer
  }, sideContent()));
};

export { TaskDetailDrawer };